<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable v-if="detailTO">
			<v-card>
				<v-card-title class="headline">
					<span>Detail Transfer Stok</span>
					<span class="pl-2 font-weight-bold">{{detailTO.to_code}}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">{{detailTO.to_type == 'in' ? 'Warehouse Pengirim' : 'Warehouse Tujuan'}}</div>
							<div v-if="detailTO.to_type == 'in' && detailTO.warehouse_from">
								<div class="pt-1">{{ detailTO.warehouse_from.warehouse_name }}</div>
								<div class="pt-1">{{ detailTO.warehouse_from.warehouse_mobilephone }}</div>
								<div class="pt-1"> {{ addressText(detailTO.warehouse_from) }}</div>
							</div>
							<div v-else-if="detailTO.to_type == 'out' && detailTO.warehouse_to">
								<div class="pt-1">{{ detailTO.warehouse_to.warehouse_name }}</div>
								<div class="pt-1">{{ detailTO.warehouse_to.warehouse_mobilephone }}</div>
								<div class="pt-1"> {{ addressText(detailTO.warehouse_to) }}</div>
							</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Transfer Stok</div>
							<v-col cols="6" class="mt-1 pa-0">
								<div class="primary rounded text-subtitle-2 text-uppercase font-weight-bold white--text text-center font-weight-bold pa-2 d-flex justify-center">
									{{detailTO.to_status | toStatusTOWH}}
								</div>
							</v-col>
							<div class="text-subtitle-1 mt-3 font-weight-bold">Catatan</div>
							<v-col cols="12" class="pa-0">
								<div class="pt-1">{{detailTO.to_note ? detailTO.to_note : '-'}}</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailTO.to_detail" hide-default-footer>
							<template v-slot:item.to_detail_quantity_requested="{ item }">
								<div>{{ item.to_detail_quantity_requested | toNumber }}</div>
							</template>
							<template v-slot:item.to_detail_quantity_transport="{ item }">
								<div>{{ item.to_detail_quantity_transport | toNumber }}</div>
							</template>
							<template v-slot:item.to_detail_quantity_delivered="{ item }">
								<div>{{ item.to_detail_quantity_delivered | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">status Transfer Order</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailTO.to_status_completed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTO.to_status == 'completed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'completed' | toStatusTO}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTO.to_status_completed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTO.to_status_processed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTO.to_status == 'processed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'processed' | toStatusTO}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTO.to_status_processed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTO.to_status_approved_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTO.to_status == 'approved' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'approved' | toStatusTO}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTO.to_status_approved_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTO.to_status_rejected_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTO.to_status == 'rejected' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'rejected' | toStatusTO}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTO.to_status_rejected_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailTO.to_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailTO.to_status == 'created' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusTO}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailTO.to_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-3" text @click="hideDialog" class="text-capitalize">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'to_detail_product_name'},
			{ text: 'Jumlah Permintaan', value: 'to_detail_quantity_requested'},
			{ text: 'Jumlah Sedang Dikirim', value: 'to_detail_quantity_transport'},
			{ text: 'Jumlah Dikirim', value: 'to_detail_quantity_delivered'},
			],
		}
	},
	computed:{
		...mapState('to', ['detailTO']),

		grandTotal(){
			let total = 0
			if (this.detailTO.to_detail) {
				this.detailTO.to_detail.forEach( (el) => {
					total += el.to_detail_product_price * el.to_detail_quantity_requested
				});
			}

			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		}
	}
}
</script>